import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import EmptyState from "../common/EmptyState";

interface TopBuyer {
  customer_id: string;
  full_name: string;
  email: string;
  total_orders: string;
  total_spent: number;
}

const DashboardRank: React.FC = () => {
  const [buyers, setBuyers] = useState<TopBuyer[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopBuyers = async () => {
      try {
        const res = await axiosInstance.get("/analytics/dashboard/venture");
        setBuyers(res.data?.data?.customers?.top_buyers || []);
      } catch (error) {
        setBuyers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTopBuyers();
  }, []);

  return (
    <div className="customer-ranking dashboard">
      <h3 className="customer-ranking-title">Customer Ranking</h3>
      <div className="customer-ranking-list">
        {loading ? (
          <div className="customer-ranking-loading">Loading...</div>
        ) : buyers.length === 0 ? (
          <EmptyState
            title="No top buyers available"
            description="There are no top buyers to display yet."
          />
        ) : (
          buyers.map((buyer) => (
            <div key={buyer.customer_id} className="customer-ranking-item">
              <div className="customer-ranking-info">
                <p className="customer-ranking-name">{buyer.full_name}</p>
                <div className="customer-ranking__date-id">
                  {/* <p className="customer-ranking-id">{buyer.customer_id}</p> */}
                  <p className="customer-ranking-email">{buyer.email}</p>
                </div>
              </div>
              <div className="customer-ranking-details">
                <p className="customer-ranking-amount">
                  ₦{buyer.total_spent.toLocaleString()}
                </p>
                <span className="customer-ranking-status customer-ranking-status-active">
                  Orders: {buyer.total_orders}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DashboardRank;
